/*@ngInject*/
const UIRemoteChangeNotificationDirective = function ($timeout, formViewerConstant) {
    let linkFunction = function ($scope, $elm, $attr) {
        let timeoutList = [],
            element = $($elm);

        function triggerNotification() {
            element.addClass('animateFieldNotification');
            element.addClass('remoteChangeNotification');

            timeoutList.push($timeout(function () {
                removeNotification();
            }, 1200));
        }

        function removeNotification() {
            element.removeClass('remoteChangeNotification');

            timeoutList.push($timeout(function () {
                removeTransition();
            }, 500));
        }

        function removeTransition() {
            element.removeClass('animateFieldNotification');
        }

        $scope.$on(formViewerConstant.event.SHOW_REMOTE_FIELD_NOTIFICATION, function () {
            triggerNotification();
        });

        $scope.$on('$destroy', function () {
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiRemoteChangeNotification', UIRemoteChangeNotificationDirective);
